export default function SectionTitle({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className="text-gold font-mono text-xs tracking-[0.35em] uppercase mb-4">{eyebrow}</div>
      )}
      <h2 className="section-heading text-4xl md:text-5xl text-white text-balance">{title}</h2>
      {subtitle && <p className="mt-4 text-white/60 text-lg text-balance">{subtitle}</p>}
    </div>
  );
}
